import axios from 'axios'
import config from '../config'

const shop = {
    state: {
       shopList: [],
       shopDetail:[],
       beauticians:[],
       sales: [],
       msg: '',
       error: false
    },
    mutations: {
       fetchShop: (state, shopList) => state.shopList = shopList,
       fetchShopDetail: (state, shopDetail) => state.shopDetail = shopDetail,
       getStatus: (state, key) => state.key = key,
       getBeauticians: (state, beauticians) => state.beauticians = beauticians,
        getSales: (state, sales) => state.sales = sales,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
       async fetchShop({commit}, shopSearch) {
         await axios({
             method:'post',
             url: config.LOAD_SHOP_LIST,
             data: shopSearch
         })
         .then((result) => {
             commit('fetchShop', result.data.shops)
         }).catch((err) => {
             console.log(err);
         });
       },
       async addShop({commit}, data) {
           await axios({
               method:'post',
               url: config.ADD_SHOP,
               data: data
           })
           .then((result) => {
               commit('ERROR', result.data.error)
               commit('MSG', result.data.msg)
           }).catch((err) => {
               console.log(err);
           });
       },
       async fetchShopDetail({commit}, data) {
          await axios({
              method:'post',
              url: config.LOAD_SHOP_DETAIL,
              data: data
          })
          .then((result) => {
              commit('fetchShopDetail', result.data.shop)
              commit('getBeauticians', result.data.beauticians)
              commit('getSales', result.data.sales)
          }).catch((err) => {
              console.log(err);
          });
       },
       async updateShopStatus({commit}, data){
        await axios({
            method:'post',
            url: config.SHOP_UPDATE_STATUS,
            data: data
        })
        .then((result) => {
            commit('ERROR', result.data.error)
            commit('MSG', result.data.msg)
        }).catch((err) => {
            console.log(err);
        });
        
       },
       async updateShop({commit}, data){
         await axios({
             method:'post',
             url: config.SHOP_UPDATE,
             data: data
         })
         .then((result) => {
             commit('ERROR', result.data.error)
             commit('MSG', result.data.msg)
         }).catch((err) => {
             console.log(err);
         });
       }
    },
    getters: {
        getShopList: state => state.shopList,
        getShopDetail: state => state.shopDetail,
        shopStatus: state => state.status,
        beauticiansItems: state => state.beauticians,
        salesItems: state => state.sales,
        getShopError: state => state.error,
        getShopMsg: state => state.msg
    }
}

export default shop;